import { IconType } from "react-icons";
import { UserModuleNameTypes } from "./models/userAccess/UserAccess.model";
import { TbBook, TbBriefcase, TbMessageHeart } from "react-icons/tb";

type NavItemTypeWithoutChild = {
  label: string;
  moduleName: string;
  path: string;
  icon: IconType;
  children?: never;
};

type NavItemTypeWithChild = {
  label: string;
  moduleName: string;
  path?: never;
  icon: IconType;
  children?: {
    label: string;
    moduleName: string;
    path: string;
    icon: IconType;
  }[];
};

export type NavItemType = NavItemTypeWithChild | NavItemTypeWithoutChild;

export const TestModuleNavigation: NavItemType[] = [
  {
    label: "Question Category",
    moduleName: UserModuleNameTypes.QUESTION_CATEGORY,
    icon: TbBriefcase,
    path: "category",
  },
  {
    label: "Question Technology",
    moduleName: UserModuleNameTypes.QUESTION_TECHNOLOGY,
    icon: TbMessageHeart,
    path: "technology",
  },
  {
    label: "Test Questions",
    moduleName: UserModuleNameTypes.TEST_QUESTION,
    icon: TbBook,
    path: "questions",
  },
  {
    label: "Test Series",
    moduleName: UserModuleNameTypes.TEST_SERIES,
    icon: TbBook,
    path: "test-series",
  },
  {
    label: "Assign Test",
    moduleName: UserModuleNameTypes.TEST_ASSIGN,
    icon: TbBook,
    path: "assign-test",
  },
  // {
  //   label: "Test Check",
  //   moduleName: UserModuleNameTypes.TEST_CHECK,
  //   icon: TbBook,
  //   path: "test-check",
  // },
];
